const url = process.env.VUE_APP_API_URL;

export default {
  namespaced: true,

  state: {
    records: [],
    recordsLoading: false,
    pagination: {
      total: 0,
      page: 1,
      itemsPerPage: 10,
      totalPages: 0,
    },
  },
  mutations: {
    setRecords(state, val) {
      state.records = val;
    },
    setRecordsLoading(state, val) {
      state.recordsLoading = val;
    },
    setPagination(state, val) {
      state.pagination = val;
    },
  },

  actions: {
    async getRecords({ commit, rootState }, params = {}) {
      const returnData = params.returnData || false;

      if (!returnData) {
        commit("setRecordsLoading", true);
      }

      try {
        // Build query string from params (exclude returnData from API call)
        const queryParams = new URLSearchParams({
          page: params.page || 1,
          itemsPerPage: params.itemsPerPage || 10,
          search: params.search || "",
          sortBy: params.sortBy || "",
          sortDesc: params.sortDesc || false,
          date_from: params.date_from || "",
          date_to: params.date_to || "",
        });

        const response = await fetch(
          `${url}dashboard/active_players_detailed?${queryParams.toString()}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${rootState.userToken}`,
            },
          }
        );

        const res = await response.json();

        if (!response.ok) {
          throw { response, res };
        } else {
          if (returnData) {
            // Return full response data for export (including pagination info)
            return {
              items: res.items,
              total: res.total,
              page: res.page,
              itemsPerPage: res.itemsPerPage,
              totalPages: res.totalPages,
            };
          } else {
            // Update state for normal operation
            commit("setRecords", res.items);
            commit("setPagination", {
              total: res.total,
              page: res.page,
              itemsPerPage: res.itemsPerPage,
              totalPages: res.totalPages,
            });
          }
        }
      } catch (error) {
        const errorStatus = error.response?.status;

        if (errorStatus == 401) {
          commit("setError", "Unauthorized", { root: true });
        } else {
          commit("setRefreshError", "Failed to load active players data", {
            root: true,
          });
        }

        if (returnData) {
          throw error; // Re-throw for export error handling
        }
      } finally {
        if (!returnData) {
          commit("setRecordsLoading", false);
        }
      }
    },
  },
};
